const resource = {
  "support": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["24/7 support"])},
  "writeUs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact us if you have any questions!"])}
}
export default resource